import React, { useState } from "react";
import PropTypes from "prop-types";
import CommonModal from "./CommonModal";
import DatePicker from "../datepicker/ModalDatePicker";
import {
  InvoiceDetails,
  fieldValidation,
  alertActions,
  buttonName
} from "../../locales/en";
import { localDateString } from "../../utils/utils";
import Modalstyle from "./modal.module.scss";
import "./modalstyle.scss";

const FeeCalculatorModal = ({ isOpen, toggle, onSubmit }) => {
  const [date, setDate] = useState(null);
  const [dateError, setDateError] = useState("");

  const handleDateChange = (newDate) => {
    setDate(newDate);
    setDateError("");
  };

  const handleSubmit = () => {
    if (!date) {
      setDateError(fieldValidation?.required);
      return;
    }
    const formattedDate = localDateString(date);
    onSubmit(formattedDate);
    setDate(null);
    toggle();
  };

  const handleClose = () => {
    setDate(null);
    setDateError("");
    toggle();
  };

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={handleClose}
      title={InvoiceDetails?.feeCalculator?.feeCalc}
      modalClassName="modal-dialog-scrollable-hide"
      bodyClassName={Modalstyle.commentModalWrap}
      footerButtons={[
        {
          label: buttonName?.close,
          className: "btn btn-secondary",
          onClick: handleClose
        },
        {
          label: alertActions?.Confirm,
          className: "btn btn-primary",
          onClick: handleSubmit
        }
      ]}
    >
      <div className="row">
        <div className="mb-3">
          <div className={Modalstyle.modalInputwrap}>
            <label className="form-label">
              {InvoiceDetails?.feeSection?.feeAddModal?.date}
            </label>
            <div className={Modalstyle.formInput}>
              <DatePicker value={date} onChange={handleDateChange} />
              {dateError && (
                <div className="text-danger small">{dateError}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </CommonModal>
  );
};

FeeCalculatorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default FeeCalculatorModal;
